module.exports = __webpack_public_path__ + "static/media/save.d19c8bb5.svg";